export default "__VITE_ASSET__9uBPROuL__"